import PropTypes from "prop-types";

function RadioImageCard({ id, image, label, value, checked, onChange }) {
  return (
    <div className="form-input form-input-image-radio-custom">
      {image && (
        <label htmlFor={id} className="form-check-image" aria-label={label}>
          <img src={image} width="72" height="72" alt="" />
        </label>
      )}

      <div className="form-check">
        <input
          required="required"
          className="form-check-input"
          id={id}
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
        />

        <label className="form-check-label" htmlFor={id} aria-label={label}>
          <p dangerouslySetInnerHTML={{ __html: label }} />
        </label>

        {image && (
          <label
            htmlFor={id}
            className="form-check-image form-check-image-mobile"
            aria-label={label}
          >
            <img src={image} width="42" height="42" alt="" />
          </label>
        )}
      </div>
    </div>
  );
}

RadioImageCard.propTypes = {
  id: PropTypes.string,
  image: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RadioImageCard;
